"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bytesToMB = void 0;

require("core-js/modules/es.number.to-fixed.js");

var bytesToMB = function bytesToMB(bytes) {
  var kb = 1024;
  return +(bytes / kb / kb).toFixed(2);
};

exports.bytesToMB = bytesToMB;